var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB3CoolingWall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 7v62h62V7H7zm58 58H15V11h50v54zM21.28 33.73l4.21-1.8-3.81-2.2 2-3.46 3.81 2.2-.54-4.54 4-.48.9 7.52L38 34.54v-7.15l-6.06-4.54 2.4-3.2L38 22.4V18h4v4.4l3.66-2.74 2.4 3.2L42 27.39v7.14L48.19 31l.9-7.51 4 .47-.54 4.54 3.81-2.2 2 3.46-3.81 2.2 4.2 1.8-1.57 3.68-7-3L44 38l6.18 3.57 7-3 1.57 3.68-4.2 1.8 3.81 2.2-2 3.46-3.81-2.2.54 4.54-4 .47-.91-7.52L42 41.46v7.14l6.06 4.54-2.4 3.2L42 53.6V58h-4v-4.4l-3.66 2.74-2.4-3.2L38 48.61v-7.15L31.82 45l-.9 7.52-4-.48.54-4.54-3.81 2.2-2-3.46 3.81-2.2-4.21-1.8 1.57-3.68 7 3L36 38l-6.19-3.57-7 3-1.53-3.7z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/B3_Cooling_wall.d5cd6897.svg";
export { SvgB3CoolingWall as ReactComponent };